import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ReceiptsAndPaymentsApiService {

  constructor(private http: HttpClient, private configService: ConfigurationService) { }
      private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API

  GetReceiptsAndPayments(AccpID:any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/ReceiptsAndPayments/GetReceiptsAndPaymentsTemplate`;
    return this.http.get<any>(url + "?AccpID=" + AccpID);
  }
}
